<template>
    <div>
        <el-select
            v-model="proposal_id"
            filterable
            clearable
            remote
            placeholder="Search by a Proposal/Author"
            :remote-method="querySearch"
            :loading="loading"
            style="width: 100%"
            @change="$emit('selected', proposal_id)"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            proposal_id: null,
            loading: false,
            options: []
        };
    },
    methods: {
        querySearch: _.debounce(function(query) {
            this.loading = true;

            axios.get(url(`admin/proposal/search?q=${query}`))
                .then(response => {
                    this.options = response.data;
                    this.loading = false;
                });
        }, 250)
    },
};
</script>
